import { bind, EPlayerType } from '@streaming/mouflon-utils';

import { TMMPEventBus } from '@utils/EventBus';

import { defaultWatchDogConfig, IWatchDogConfig } from './WatchDog.config';
import { EWatchDogEvent, TWatchDogsEventsPayload } from './WatchDog.events';

export class WatchDog {
  private _playerType: EPlayerType | null = null;
  private _lastPlayerTypeSwitchTimestamp: number = -1;
  private _config: IWatchDogConfig = { ...defaultWatchDogConfig };
  private readonly _onAlivePlayerListener: string;

  constructor(private _eventBusInstance: TMMPEventBus) {
    this._onAlivePlayerListener = this._eventBusInstance.subscribe(
      EWatchDogEvent.ALIVE_PLAYER,
      this._onAlivePlayer,
    );
  }

  public destroy(): void {
    this._eventBusInstance.unsubscribe(this._onAlivePlayerListener);
  }

  public updateConfig(config: Partial<IWatchDogConfig>): void {
    if (config.shouldStopPlayer !== undefined) {
      this._config.shouldStopPlayer = config.shouldStopPlayer;
    }
    if (config.ignoreDurationMs !== undefined) {
      this._config.ignoreDurationMs = config.ignoreDurationMs;
    }
  }

  public changePlayerType(playerType: EPlayerType): void {
    this._playerType = playerType;
    this._lastPlayerTypeSwitchTimestamp = performance.now();
  }

  @bind
  private _onAlivePlayer({
    playerType,
  }: TWatchDogsEventsPayload<EWatchDogEvent.ALIVE_PLAYER>): void {
    if (
      performance.now() - this._lastPlayerTypeSwitchTimestamp < this._config.ignoreDurationMs ||
      this._playerType === playerType ||
      !this._config.shouldStopPlayer
    ) {
      return;
    }
    this._eventBusInstance.publish(EWatchDogEvent.ANOTHER_ACTIVE_PLAYER, {
      wrongPlayer: playerType,
    });
  }
}
